import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { issueService } from '../services/api';

function IssueDetail() {
  const { id } = useParams();
  const [issue, setIssue] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchIssue = async () => {
      try {
        const response = await issueService.getById(id);
        setIssue(response.data);
      } catch (err) {
        setError('خطا در بارگذاری شماره');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchIssue();
  }, [id]);

  if (loading) return <div className="max-w-7xl mx-auto px-4 py-12 text-center">در حال بارگذاری...</div>;
  if (error) return <div className="max-w-7xl mx-auto px-4 py-12 text-center text-red-600">{error}</div>;
  if (!issue) return <div className="max-w-7xl mx-auto px-4 py-12 text-center">شماره یافت نشد</div>;

  return (
    <div className="max-w-7xl mx-auto px-4 py-12">
      <Link to="/issues" className="flex items-center gap-2 text-blue-600 hover:text-blue-800 mb-8">
        <ArrowRight size={20} />
        بازگشت به شماره‌ها
      </Link>

      <div className="bg-gradient-to-r from-blue-600 to-blue-800 text-white p-8 rounded-lg mb-8">
        <h1 className="text-4xl font-bold mb-2">{issue.title}</h1>
        <p className="text-xl text-blue-100">جلد {issue.volume} - شماره {issue.number}</p>
        <p className="text-blue-100 mt-4">{new Date(issue.publicationDate).toLocaleDateString('fa-IR')}</p>
      </div>

      <div className="bg-white p-8 rounded-lg shadow-md mb-8">
        <h2 className="text-2xl font-bold mb-4">درباره این شماره</h2>
        <p className="text-gray-700 leading-relaxed">{issue.description}</p>
      </div>

      <div className="bg-white p-8 rounded-lg shadow-md">
        <h2 className="text-2xl font-bold mb-6">مقالات این شماره</h2>
        {issue.articles && issue.articles.length > 0 ? (
          <div className="space-y-4">
            {issue.articles.map((article) => (
              <Link
                key={article.id}
                to={`/articles/${article.id}`}
                className="block p-6 border-r-4 border-blue-600 bg-gray-50 hover:bg-gray-100 transition rounded-lg"
              >
                <h3 className="text-lg font-semibold mb-2">{article.title}</h3>
                <p className="text-gray-600 mb-3 line-clamp-2">{article.abstract}</p>
                <div className="flex justify-between items-center text-sm text-gray-500">
                  <span>نویسندگان: {article.articleAuthors?.map(aa => aa.author.firstName + ' ' + aa.author.lastName).join('، ')}</span>
                  <span className={`px-3 py-1 rounded-full text-xs font-semibold ${
                    article.status === 'Published' ? 'bg-green-100 text-green-800' :
                    article.status === 'Under Review' ? 'bg-yellow-100 text-yellow-800' :
                    'bg-gray-100 text-gray-800'
                  }`}>
                    {article.status}
                  </span>
                </div>
              </Link>
            ))}
          </div>
        ) : (
          <p className="text-gray-500 text-center py-8">هیچ مقاله‌ای برای این شماره وجود ندارد</p>
        )}
      </div>
    </div>
  );
}

export default IssueDetail;
